import { Locale } from "lib/Intl";

export const helpCenterLocaleMap: Record<Locale, string> = {
  "pl-pl": "pl",
  en: "en",
  "en-se": "en",
  "en-dk": "en",
  "en-us": "en",
  "en-gb": "en",
  "nl-be": "nl",
  nl: "nl",
  de: "de",
  "de-at": "de",
  "es-es": "es",
  fr: "fr",
  "it-it": "it",
};
